
import BuscaClienteContato from "@/modules/CRM/components/BuscaClienteContato";
import crmService from "@/modules/CRM/services/crmService";

export default {
  name: "crm-tarefas",
  components: { BuscaClienteContato },
  data() {
    return {
      buscaTimer: null,
      drawerEditando: false,
      drawerForm: this.emptyDrawerForm(),
      drawerVisible: false,
      form: this.emptyForm(),
      filtros: {
        busca: "",
        status: "todos",
      },
      loading: false,
      loadingDrawerSave: false,
      pagination: {
        page: 1,
        perPage: 10,
        total: 0,
      },
      perPageOptions: [
        { value: 10, text: "10" },
        { value: 20, text: "20" },
        { value: 30, text: "30" },
        { value: 50, text: "50" },
      ],
      statusFilterOptions: [
        { value: "todos", text: "Todos os status" },
        { value: "agendadas", text: "Agendadas" },
        { value: "atrasadas", text: "Atrasadas" },
        { value: "concluidas", text: "Concluídas" },
      ],
      tarefaSelecionada: null,
      tarefas: [],
      tiposTarefa: [],
      usuarios: [],
      vinculoSelecionado: null,
    };
  },
  computed: {
    lastPage() {
      return Math.max(
        1,
        Math.ceil(this.pagination.total / this.pagination.perPage)
      );
    },
    tipos() {
      const ativos = this.tiposTarefa.filter((tipo) => tipo.ativo !== false);
      const tipos = ativos.length
        ? ativos
        : [
            { nome: "Tarefa", chave: "tarefa" },
            { nome: "Ligação", chave: "ligacao" },
            { nome: "Reunião", chave: "reuniao" },
            { nome: "Nota", chave: "nota" },
            { nome: "Follow-up", chave: "follow_up" },
          ];

      return tipos.map((tipo) => ({
        value: tipo.chave,
        text: tipo.nome,
      }));
    },
    usuarioOptionsSemTodos() {
      return this.usuarios.map((usuario) => ({
        value: usuario.id_usuario,
        text: usuario.nome || usuario.usuario,
      }));
    },
  },
  mounted() {
    this.loadTiposTarefa();
    this.loadUsuarios();
    this.loadAtividades();
  },
  beforeDestroy() {
    clearTimeout(this.buscaTimer);
  },
  methods: {
    emptyForm() {
      return {
        titulo: "",
        tipo: "tarefa",
        vencimento_em: null,
        descricao: "",
        id_crm_oportunidade: null,
        id_crm_contato: null,
      };
    },
    emptyDrawerForm() {
      return {
        titulo: "",
        tipo: "tarefa",
        id_usuario: null,
        vencimento_em: null,
        descricao: "",
      };
    },
    atividadeParams() {
      const params = {
        busca: this.filtros.busca,
        page: this.pagination.page,
        per_page: this.pagination.perPage,
        sort: {
          field: "vencimento_em",
          type: "asc",
        },
      };

      if (this.filtros.status === "agendadas") {
        params.status = "aberta";
      }

      if (this.filtros.status === "atrasadas") {
        params.periodo = "atrasadas";
      }

      if (this.filtros.status === "concluidas") {
        params.status = "concluida";
      }

      return params;
    },
    async loadAtividades() {
      this.loading = true;

      try {
        const { data } = await crmService.atividades(this.atividadeParams());
        this.tarefas = this.normalizeCollection(data);
        this.pagination.total = Number(data?.total || this.tarefas.length || 0);
        this.pagination.page = Number(
          data?.current_page || this.pagination.page
        );
        this.pagination.perPage = Number(
          data?.per_page || this.pagination.perPage
        );
      } catch (error) {
        this.tarefas = [];
        this.pagination.total = 0;
      } finally {
        this.loading = false;
      }
    },
    async loadTiposTarefa() {
      const { data } = await crmService.tiposTarefaConfiguracao();
      this.tiposTarefa = this.normalizeCollection(data);
    },
    async loadUsuarios() {
      const { data } = await crmService.usuarios({
        per_page: 100,
        page: 1,
        sort: [{ field: "nome", type: "asc" }],
      });
      this.usuarios = this.normalizeCollection(data);
    },
    abrirDrawer(tarefa) {
      this.tarefaSelecionada = tarefa;
      this.drawerForm = this.formFromTarefa(tarefa);
      this.drawerEditando = false;
      this.drawerVisible = true;
    },
    abrirModal() {
      this.form = this.emptyForm();
      this.form.tipo = this.tipos.length ? this.tipos[0].value : "tarefa";
      this.vinculoSelecionado = null;
      this.$bvModal.show("crm-tarefa-modal");
    },
    cancelarEdicaoDrawer() {
      this.drawerForm = this.formFromTarefa(this.tarefaSelecionada);
      this.drawerEditando = false;
    },
    canEditTarefa(tarefa) {
      return tarefa && !this.isConcluida(tarefa);
    },
    async concluirTarefa(tarefa) {
      if (!this.canEditTarefa(tarefa)) {
        return;
      }

      await crmService.concluirAtividade({
        id_crm_atividade: tarefa.id_crm_atividade,
      });
      this.$toast.success("Tarefa concluída com sucesso.");
      this.drawerEditando = false;
      this.loadAtividades();
      this.tarefaSelecionada = {
        ...tarefa,
        status: "concluida",
        concluido_em: new Date().toISOString(),
      };
    },
    abrirOportunidade(tarefa) {
      if (!tarefa || !tarefa.id_crm_oportunidade) {
        return;
      }

      this.$router.push({
        name: "crmOportunidadeDetalhe",
        params: { id: tarefa.id_crm_oportunidade },
        query: { origem: "tarefas" },
      });
    },
    debouncedLoadAtividades() {
      clearTimeout(this.buscaTimer);
      this.buscaTimer = setTimeout(() => {
        this.pagination.page = 1;
        this.loadAtividades();
      }, 350);
    },
    formatDateTime(value) {
      if (!value) {
        return "Sem data";
      }

      const date = new Date(value);

      if (Number.isNaN(date.getTime())) {
        return "Sem data";
      }

      const formatted = new Intl.DateTimeFormat("pt-BR", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      }).format(date);

      return formatted.replace(",", " às");
    },
    formFromTarefa(tarefa) {
      if (!tarefa) {
        return this.emptyDrawerForm();
      }

      return {
        titulo: tarefa.titulo || "",
        tipo:
          tarefa.tipo || (this.tipos.length ? this.tipos[0].value : "tarefa"),
        id_usuario: tarefa.id_usuario || null,
        vencimento_em: this.toDateTimeLocal(tarefa.vencimento_em),
        descricao: tarefa.descricao || "",
      };
    },
    iniciarEdicaoDrawer() {
      this.drawerForm = this.formFromTarefa(this.tarefaSelecionada);
      this.drawerEditando = true;
    },
    isConcluida(tarefa) {
      return tarefa && tarefa.status === "concluida";
    },
    isLate(tarefa) {
      if (!tarefa || this.isConcluida(tarefa) || !tarefa.vencimento_em) {
        return false;
      }

      const date = new Date(tarefa.vencimento_em);

      return !Number.isNaN(date.getTime()) && date < new Date();
    },
    normalizeCollection(data) {
      if (Array.isArray(data)) {
        return data;
      }

      if (data && Array.isArray(data.data)) {
        return data.data;
      }

      return [];
    },
    responseData(response) {
      return response?.data?.data || response?.data || null;
    },
    async salvar() {
      if (!this.form.titulo) {
        this.$toast.error("Informe o título da tarefa.");
        return;
      }

      if (!this.vinculoSelecionado) {
        this.$toast.error("Selecione um contato ou oportunidade.");
        return;
      }

      await crmService.criarAtividade({
        ...this.form,
        id_crm_oportunidade: this.vinculoSelecionado.id_crm_oportunidade,
        id_crm_contato: this.vinculoSelecionado.id_crm_contato,
      });
      this.$toast.success("Tarefa criada com sucesso.");
      this.$bvModal.hide("crm-tarefa-modal");
      this.pagination.page = 1;
      this.loadAtividades();
    },
    async salvarEdicaoDrawer() {
      if (
        !this.tarefaSelecionada ||
        !this.canEditTarefa(this.tarefaSelecionada)
      ) {
        return;
      }

      if (!this.drawerForm.titulo) {
        this.$toast.error("Informe o título da tarefa.");
        return;
      }

      if (!this.drawerForm.id_usuario) {
        this.$toast.error("Informe o responsável da tarefa.");
        return;
      }

      this.loadingDrawerSave = true;

      try {
        const response = await crmService.atualizarAtividade({
          id_crm_atividade: this.tarefaSelecionada.id_crm_atividade,
          titulo: this.drawerForm.titulo,
          tipo: this.drawerForm.tipo,
          id_usuario: this.drawerForm.id_usuario,
          vencimento_em: this.toApiDateTime(this.drawerForm.vencimento_em),
          descricao: this.drawerForm.descricao,
        });
        const atividade = this.responseData(response);
        const tarefaAtualizada = this.mergeTarefaAtualizada(
          this.tarefaSelecionada,
          atividade
        );

        this.tarefaSelecionada = tarefaAtualizada;
        this.atualizarTarefaNaLista(tarefaAtualizada);
        this.drawerEditando = false;
        this.$toast.success("Tarefa atualizada com sucesso.");
        this.loadAtividades();
      } finally {
        this.loadingDrawerSave = false;
      }
    },
    async criarContatoRapido(payload) {
      const contatoPayload =
        typeof payload === "string"
          ? { nome: payload, origem_criacao_rapida: true }
          : { ...payload, origem_criacao_rapida: true };
      const { data } = await crmService.criarContato(contatoPayload);
      const contato = data.contato || data;
      this.vinculoSelecionado = {
        tipo: "contato",
        label: contato.nome,
        id_crm_contato: contato.id_crm_contato,
        id_pessoa: contato.id_pessoa || null,
        id_crm_oportunidade: null,
        raw: contato,
      };
      this.$toast.success("Contato criado e selecionado.");
    },
    statusClass(tarefa) {
      if (this.isConcluida(tarefa)) {
        return "is-done";
      }

      return this.isLate(tarefa) ? "is-late" : "is-scheduled";
    },
    statusTexto(tarefa) {
      if (this.isConcluida(tarefa)) {
        return "Concluída";
      }

      return this.isLate(tarefa) ? "Atrasada" : "Agendada";
    },
    toApiDateTime(value) {
      return value ? value.replace("T", " ") : null;
    },
    toDateTimeLocal(value) {
      if (!value) {
        return null;
      }

      const date = new Date(value);

      if (Number.isNaN(date.getTime())) {
        return null;
      }

      const pad = (number) => String(number).padStart(2, "0");

      return (
        [
          date.getFullYear(),
          pad(date.getMonth() + 1),
          pad(date.getDate()),
        ].join("-") + `T${pad(date.getHours())}:${pad(date.getMinutes())}`
      );
    },
    atualizarTarefaNaLista(tarefaAtualizada) {
      this.tarefas = this.tarefas.map((tarefa) =>
        tarefa.id_crm_atividade === tarefaAtualizada.id_crm_atividade
          ? tarefaAtualizada
          : tarefa
      );
    },
    mergeTarefaAtualizada(tarefaAtual, atividade) {
      const idUsuario = atividade?.id_usuario || this.drawerForm.id_usuario;
      const usuarioSelecionado = this.usuarios.find(
        (usuario) => Number(usuario.id_usuario) === Number(idUsuario)
      );

      return {
        ...tarefaAtual,
        ...(atividade || {}),
        id_usuario: idUsuario,
        titulo: atividade?.titulo || this.drawerForm.titulo,
        tipo: atividade?.tipo || this.drawerForm.tipo,
        descricao:
          atividade &&
          Object.prototype.hasOwnProperty.call(atividade, "descricao")
            ? atividade.descricao
            : this.drawerForm.descricao,
        vencimento_em:
          atividade?.vencimento_em ||
          this.toApiDateTime(this.drawerForm.vencimento_em),
        usuario:
          atividade?.usuario ||
          usuarioSelecionado?.nome ||
          usuarioSelecionado?.usuario ||
          tarefaAtual.usuario,
      };
    },
    tipoTexto(tipo) {
      const option = this.tipos.find((item) => item.value === tipo);

      return option ? option.text : tipo || "Tarefa";
    },
    trocarFiltroStatus() {
      this.pagination.page = 1;
      this.loadAtividades();
    },
    trocarPagina(page) {
      this.pagination.page = Math.min(Math.max(page, 1), this.lastPage);
      this.loadAtividades();
    },
    trocarPorPagina() {
      this.pagination.page = 1;
      this.loadAtividades();
    },
  },
};
